/*
 * @Author: qiuz
 * @Github: <https://github.com/qiuziz>
 * @Date: 2018-11-22 15:20:52
 * @Last Modified by: qiuz
 * @Last Modified time: 2018-11-22 17:16:59
 */

import * as React from 'react';
import './index.less';
import { adaptorPC } from '../../common/utils';
import LayoutHeader from '../../component/header';
import Model from '../../component/model';
import LayoutFooter from '../../component/footer';

import LogoImg from '@assets/images/logo.png';
import logoMobilePng from '@assets/images/app-logo.png';
import WashImg from '@assets/images/wash.png';
import washMobileJpg from '@assets/images/app-wash.png';
import OilImg from '@assets/images/oil.png';
import oilMobileJpg from '@assets/images/app-oil.png';
import IllegalImg from '@assets/images/illegal.png';
import illegalMobileJpg from '@assets/images/app-illegal.png';
import ch_app from '../../assets/images/ch-app.png';

const IS_PC = adaptorPC();

class Dashboard extends React.Component<any, any> {
	constructor(props: any) {
		super(props);
		this.state = {
			isPC: IS_PC,
			headerList: [
				{
					title: '首页',
					link: '#',
					anchor: 'home'
				},
				{
					title: '特惠洗车',
					link: '#/wash',
					anchor: 'wash'
				},
				{
					title: '加油充值',
					link: '#/oil',
					anchor: 'oil'
				},
				{
					title: '违章查询',
					link: '#/illegal',
					anchor: 'illegal'
				},
			]
		}

	}

	// 关闭弹窗
	closePop() {
		this.setState({
			showModel: false
		})
	}

	// 放大图片
	enlarge() {
		this.setState({
			showModel: true
		})
	}
	public render() {
		const { headerList, isPC, showModel } = this.state;
		console.log(showModel);
		return (
			<div className="dashboard">
				<LayoutHeader data={headerList} isPC={isPC} />
				<div id="home" className="wrap home">
					{
						isPC ? <img src={LogoImg} alt="橙牛汽车管家app，您的专属汽车管家" /> : <img src={logoMobilePng} alt="橙牛汽车管家app，您的专属汽车管家" className="wrap_mobile" onClick={this.enlarge.bind(this)} />
					}
				</div>
				<div id="wash" className="wrap wash">
					{
						isPC ? <img src={WashImg} alt="特惠洗车，全国30000+门店覆盖" /> : <img src={washMobileJpg} alt="特惠洗车，全国30000+门店覆盖" className="wrap_mobile" />
					}
				</div>
				<div id="oil" className="wrap oil">
					{
						isPC ? <img src={OilImg} alt="加油充值，98折全网低价" /> : <img src={oilMobileJpg} alt="加油充值，98折全网低价" className="wrap_mobile" />
					}
				</div>
				<div id="illegal" className="wrap illegal">
					{
						isPC ? <img src={IllegalImg} alt="违章查询，覆盖全国300+城市" /> : <img src={illegalMobileJpg} alt="违章查询，覆盖全国300+城市" className="wrap_mobile" />
					}
				</div>
				<LayoutFooter />
				<Model isOpen={showModel} onClose={this.closePop.bind(this)} content={{ url: ch_app, title: '橙牛App' }} />
			</div>
		);
	}
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/container/dashboard/index.tsx